export const template = [
  {
    key: 'patient',
    value:
      'Spoke to {{{ patient }}} and notified them they are on a recorded line for quality and compliance purposes.',
  },
  {
    key: 'monthly',
    value: '{{{ monthly }}}.',
  },
  {
    key: 'feeling',
    value: 'Patient stated they are feeling {{{ feeling }}}.',
  },
  {
    key: 'reading',
    value: '{{{ reading }}}.',
  },
  {
    key: 'type',
    value: '{{{ type }}}.',
  },
  {
    key: 'deviceeducation',
    value: '{{{ deviceeducation }}}.',
  },
  {
    key: 'medication',
    value: '{{{ medication }}}.',
  },
  {
    key: 'last',
    value: 'Their last doctor’s appointment was {{{ last }}}',
  },
  {
    key: 'next',
    value: ' and their next upcoming doctor’s appointment is {{{ next }}}.',
  },
  {
    key: 'reminder',
    value: '{{{ patient }}} was reminded to {{{ reminder }}}.',
  },
  {
    key: 'coordination',
    value: '{{{ coordination }}}.',
  },
  {
    key: 'contact',
    value: 'They stated their preferred contact method is {{{ contact }}}.',
  },
  {
    key: 'comments',
    value: '{{{ comments }}}.',
  },
  {
    key: 'patient',
    value:
      '{{{ patient }}} was reminded that they can reach us at 888-407-4108 or by text 90105.',
  },
];

export const forms = [
  {
    id: 'patient',
    type: 'CHECKBOX',
    title:
      'Did you speak to patient? Choose other if unlisted family member & type in their relationship. (Ex: Daughter in law) Add name of individual you spoke to in other.',
    choices: ['Patient', 'Spouse', 'Caregiver'],
    hasOtherOption: true,
    isRequired: true,
    disabled: false,
  },
  {
    id: 'monthly',
    type: 'CHECKBOX',
    title: 'Monthly Interaction',
    choices: [
      'This is a monthly courtesy call for the Remote Patient Monitoring services you are enrolled in',
      'and please expect another call from Chronic Care Management services you are enrolled in',
    ],
    hasOtherOption: false,
    isRequired: true,
    disabled: false,
  },
  {
    id: 'feeling',
    type: 'TEXT',
    title: 'How are you feeling today?',
    isRequired: true,
    disabled: false,
  },
  {
    id: 'reading',
    type: 'CHECKBOX',
    title: 'Did the patient take a reading?',
    choices: [
      'The patient agreed to take a reading with me over the phone and it was successfully received',
      'The patient has recent reading that was received and reviewed',
      'The patient was not available to take a reading at this time',
    ],
    hasOtherOption: true,
    isRequired: true,
    disabled: false,
  },
  {
    id: 'type',
    type: 'TEXT',
    title: 'Type/Reading  (Ex: Blood Pressure: 105/64 mmHg Pulse: 55 bpm)',
    isRequired: false,
    disabled: false,
  },
  {
    id: 'deviceeducation',
    type: 'CHECKBOX',
    title:
      'Are you having any issues with your device? Do you need any supplies for your device?',
    choices: [
      'Provided device education to avoid inaccurate readings on',
      'Confirmed address and ordered consumables for',
      'Performed device troubleshooting on',
      'Patient denied any concerns with device(s)',
    ],
    hasOtherOption: true,
    isRequired: false,
    disabled: false,
  },
  {
    id: 'medication',
    type: 'CHECKBOX',
    title: 'Do you need any refills on your medication with Dr ____?',
    choices: [
      'Patient states they need refills on their medication',
      'Patient states they do not need refills on their medication at this time',
    ],
    hasOtherOption: true,
    isRequired: true,
    disabled: false,
  },
  {
    id: 'last',
    type: 'TEXT',
    title: "Last doctor's appointment",
    isRequired: true,
    disabled: false,
  },
  {
    id: 'next',
    type: 'CHECKBOX',
    title: "Next doctor's appointment",
    choices: [
      'not scheduled and they are not currently requesting an appointment',
      'not scheduled and they would like to schedule an appointment. I triggered Request Appointment on Evelyn',
    ],
    hasOtherOption: true,
    isRequired: true,
    disabled: false,
  },
  {
    id: 'contact',
    type: 'CHECKBOX',
    title: 'Preferred Contact Method',
    choices: ['Email', 'Phone', 'SMS'],
    hasOtherOption: false,
    isRequired: true,
    disabled: false,
  },
  {
    id: 'reminder',
    type: 'CHECKBOX',
    title: 'Reminders',
    choices: [
      'take their readings daily',
      'allow the device to shut off on its own',
      'charge their device 2-3 hours weekly',
    ],
    hasOtherOption: false,
    isRequired: true,
    disabled: false,
  },
  {
    id: 'coordination',
    type: 'CHECKBOX',
    title: 'How can we improve your experience with our program?',
    choices: [
      'The patient stated they are satisfied and have no recommendations for our services',
    ],
    hasOtherOption: true,
    isRequired: false,
    disabled: false,
  },
  {
    id: 'comments',
    type: 'TEXT',
    title: 'Additional comments',
    isRequired: false,
    disabled: false,
  },
];
